import { Box, Link, Stack, styled } from "@mui/material"
import { Link as NavLink } from "react-router-dom"
import { Fragment, useState } from "react"
import SidebarMenu from "./SidebarMenu"
import { menus } from "./data"
import Images from "../../../assets/js/Images"

const Image = styled("img")(() => ({}))


const SidebarContainer = styled("div")(() => ({
  top: "0",
  left: "0",
  bottom: "0",
  zIndex: "200",
  width: "300px",
  color: "white",
  height: "100vh",
  display: "flex",
  position: "fixed",
  overflowY: "auto",
  flexDirection: "column",
  transition: "all 350ms ease",
}))

function Sidebar({ active, sidebarDeActive }) {
  const [activeIndex, setActiveIndex] = useState(null)

  return (
    <Fragment>
      {active &&
        <Box
          sx={{
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            zIndex: "100",
            position: "fixed",
            bgcolor: "#00000080",
            display: { laptop: "none" }
          }}
          onClick={sidebarDeActive}
        />
      }
      <SidebarContainer
        as="aside"
        className="custom-scroller"
        sx={{ bgcolor: "dark.main" }}
      >
        <Box sx={{ textAlign: "center" }}>
          <Box sx={{ py: 4, px: 2 }}>
            <Link
              underline="none"
              component={NavLink}
              to="/dashboard"
              sx={{ display: "inline-block" }}
            >
              <Image
                sx={{
                  height: "50px",
                  width: "100%",
                  objectFit: "contain",
                }}
                alt="logo"
                src={Images?.LogoWhite}
              />
            </Link>
          </Box>
        </Box>

        <Stack sx={{ px: 2 }} spacing={1}>
          {menus?.map((menu, i) => (
            <SidebarMenu
              key={i}
              index={i}
              menu={menu}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              sidebarDeActive={sidebarDeActive}
            />
          ))
          }
        </Stack>
      </SidebarContainer >
    </Fragment>
  )
}

export default Sidebar